module.exports = __webpack_public_path__ + "static/images/yoga.6dedfee045d6f77bf2ff1f4ac1fd8591.svg";